export const PartnerPaths = {
	Index: {
		route: "/partners",
		path: "/partners",
	},
	Detail: {
		route: "/partners/:id/detail",
		path: (id: number) => `/partners/${id}/detail`,
	},
	Edit: {
		route: "/partners/:id/edit",
		path: (id: number) => `/partners/${id}/edit`,
	},
	Orders: {
		route: "/partners/:id/orders",
		path: (id: number) => `/partners/${id}/orders`,
	},
	Balance: {
		route: "/partners/:id/balance",
		path: (id: number) => `/partners/${id}/balance`,
	},
	Invoice: {
		route: "/partners/:id/invoice",
		path: (id: number) => `/partners/${id}/invoice`,
	},
	Availability: {
		route: "/partners/:id/availability",
		path: (id: number) => `/partners/${id}/availability`,
	},
	Create: {
		route: "/partners/create",
		path: () => "/partners/create",
	},
	Calendar: {
		route: "/partners/calendar",
		path: "/partners/calendar",
	},
	PartnershipRecords: {
		route: "/partners/partnership-records",
		path: "/partners/partnership-records",
	},
};
